const Nav = {
  $nav: null,
  $button: null,
  $content: null,

  toggleMenu(event) {
    event.stopPropagation(); 
    this.$content.classList.toggle('is-active');
    this.$button.classList.toggle('is-active');
  },

  closeMenu() {
    if (this.$content.classList.contains('is-active')) {
      this.$content.classList.remove('is-active');
      this.$button.classList.remove('is-active');
    }
  },

  bindEvents() {
    if (this.$button) {
      this.$button.addEventListener('click', this.toggleMenu.bind(this));
    }
    
    document.addEventListener('click', (event) => {
      if (this.$nav && !this.$nav.contains(event.target)) {
        this.closeMenu();
      }
    });
  },

  init() {
    this.$nav = DOM.select('[data-selector="nav"]');
    if (!this.$nav) return;

    this.$button = DOM.find(this.$nav, '[data-action="show.nav"]');
    this.$content = DOM.find(this.$nav, '[data-selector="nav.content"]');

    if (!this.$button || !this.$content) {
      console.warn("Ошибка: $button или $content не найдены");
      return;
    }

    if (this.$button instanceof NodeList) this.$button = this.$button[0];
    if (this.$content instanceof NodeList) this.$content = this.$content[0];

    this.bindEvents();
  }
};

export default Nav;